import React, { useEffect, useState } from "react";
import { FaFolderOpen, FaFolder } from "react-icons/fa";
import { GrDocumentUpdate } from "react-icons/gr";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import TreeView from "./components/TreeView";
import { useGetOrgStructureTree, useUPDATECAVOrgStructureTree } from "./hook/useSetting";
import { useOrgunitListData } from "../Onboarding/hooks/useOnBoard";
import { Spinner } from "reactstrap";
import ListView from "./components/ListView";

interface OrgNode {
  id: string;
  name: string;
  children?: OrgNode[];
}

// const data: OrgNode[] = [
//   {
//     id: "1",
//     name: "Mumbai | 600003 - Bhavesh Barchha- 19377",
//   },
//   {
//     id: "2",
//     name: "Mumbai | 500014 - R Raghavendran- 840258",
//   },
//   {
//     id: "3",
//     name: "Gulbarga ZM | 400205 - Chandrahas Agnihotri- 850902",
//     children: [
//       {
//         id: "3-1",
//         name: "Ernakulam Rm | 300316 - SHINE S N- 882029",
//         children: [
//           {
//             id: "3-1-1",
//             name: "Ernakulam | 200307 - Abin Baby- 871181",
//             children: [
//               {
//                 id: "3-1-1-1",
//                 name: "Quilon | 101084 - Vyshnav J. Pillai- 881690",
//                 children: [
//                   {
//                     id: "3-1-1-1-1",
//                     name: "Kottayam | 101085 - Alan Biju- 881029",
//                   },
//                   {
//                     id: "3-1-1-1-2",
//                     name: "Trivandrum | 103544 - Midhun B.- 877680",
//                   },
//                   {
//                     id: "3-1-1-1-3",
//                     name: "Ernakulam | 101063 - Afrideen A- 880266",
//                   },
//                 ],
//               },
//               {
//                 id: "3-1-1-2",
//                 name: "Calicut | 200313 - Muhammed Rafi NK- 878635",
//               },
//             ],
//           },
//         ],
//       },
//       { id: "3-2", name: "Gulbarga Rm | 300513 - Mahadev Wadevar- 870021" },
//       { id: "3-3", name: "Bangalore Rm | 300114 - B k naveen.- 825887" },
//     ],
//   },
//   {
//     id: "4",
//     name: "Hyderabad ZM | 400094 - Nalla Ganesh Reddy- 818100",
//   },
//   {
//     id: "5",
//     name: "West ZM | 400028 - Dattatreya Uttam Khade- 818650",
//   },
// ];

const TreeNode: React.FC<{ node: OrgNode }> = ({ node }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div key={node.id} style={{ marginLeft: "20px", marginTop: "10px" }}>
      <button
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        {node.children ? (
          isOpen ? (
            <FaFolderOpen style={{ marginRight: "8px", color: "#808080" }} />
          ) : (
            <FaFolder style={{ marginRight: "8px", color: "#808080" }} />
          )
        ) : (
          <FaFolder style={{ marginRight: "8px", color: "#808080" }} />
        )}
        <span style={{ color: "#A9A9A9", fontWeight: "300" }}>{node.name}</span>
      </button>

      {/* {isOpen && node.children && (
        <div style={{ paddingLeft: "20px" }}>
          {node.children.map((child) => (
            <TreeNode key={child.id} node={child} />
          ))}
        </div>
      )} */}
    </div>
  );
};

const OrganisationStructure: React.FC = () => {
  const [orgUnit, setOrgUnit] = React.useState<any>(59);
  const [view, setView] = useState(1);

  const { data: orgList } = useOrgunitListData({
    enable: true,
  });
  const { data: OrgTree, isLoading } = useGetOrgStructureTree({
    params: {
      OrgUnitId: orgUnit.id || 59,
    },
    enable: true,
  });

const { data: updateCav, isLoading:isUpdate, refetch } = useUPDATECAVOrgStructureTree({
 
    id: orgUnit.id || 59,
  
  enable: false, // <-- prevents automatic fetching
});


  const formateOrgData = orgList?.data?.map((item: any) => ({
    id: item.OrgunitId,
    label: item.UnitName,
  }));

  console.log("orgnaisation structure", formateOrgData);
  return (
    <div className="p-4">
      <PageHeader
        title="Organisation Structure"
        buttons={[
          {
            label: "Excel",
            onClick: () => alert("Action 2 clicked"),
            color: "#43B9B2",
          },
          {
            label: "CSV",
            onClick: () => alert("Action 3 clicked"),
            color: "#43B9B2",
          },
        ]}
      />
      <div
        className="p-4"
        style={{ backgroundColor: "#fff", borderRadius: "10px" }}
      >
        <div
          className="mb-4"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <h3 className="text-md text-gray-700">Organization Structure</h3>
          <div>
            <RoundedDropdown
              options={formateOrgData || []}
              onSelect={(e) => {
                console.log(e);
                setOrgUnit(e);
              }}
              defaultLabel="Alcare"
              width="auto"
              isShowHeading
              DropdownHeading="OrgUnit"
              headingColor="#2e8dd3"
            />
            {/* <RoundedDropdown
            options={[
              {id:1,label:'Show in Tree view'},
              {id:2,label:'Show in List view'},
            ]}
            onSelect={(e) => {
              console.log(e);
              setOrgUnit(e)
            }}
            // defaultLabel="Alcare"
            width="auto"
            isShowHeading
            DropdownHeading=""
            headingColor="#2e8dd3"
          /> */}

            <select
              id="orgUnitSelect"
              value={view}
              onChange={(e) => setView(Number(e.target.value))}
              style={{
                padding: "8px 12px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                marginTop: "5px",
                width: "200px",
                margin: 5,
              }}
            >
              <option value={1}>Show in Tree view</option>
              <option value={2}>Show in List view</option>
            </select>
          </div>
        </div>

        <div>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "20px",
              }}
            >
              <Spinner color="primary" />
            </div>
          ) : (
            view === 1 ? (
              <TreeView
                data={OrgTree?.data?.data}
              />
            ) : (
              <ListView data={OrgTree?.data?.data}/>
            )
          )}

        </div>
  <div
  style={{
    marginTop: 10,
    backgroundColor: "#F4F7F9",
    display: "inline-flex",
    alignItems: "center",
    padding: "6px 12px",
    borderRadius: "5px",
    color: "#333",
    fontSize: "14px",
    fontWeight: 500,
    border: "1px solid #ccc",
    cursor: "pointer",
  }}
  onClick={() => {
    if (!orgUnit) return alert("Please select an Org Unit");
    refetch();
  }}
>
  <GrDocumentUpdate style={{ marginRight: 8 }} />
  <span>{isLoading ? "Updating..." : "Update Cav"}</span>
</div>

      </div>
    </div>
  );
};

export default OrganisationStructure;
